var regexCloseSquareBracket = /]|^\[/g;
var regexOpenSquareBracket = /\.?\[/g;

module.exports = function (object, path, defaultValue) {
  // Handle the case that the object is undefined or not an object
  if (!object || Object(object) !== object) {
    return defaultValue;
  } // A) If the path is an array, we can just use that
  // B) If the path is a string, convert it into an array by migrating
  //    array-style `[foo]` accessors into object-style `.foo` accessors


  var cleanPath = Array.isArray(path) ? path : path.replace(regexCloseSquareBracket, '').replace(regexOpenSquareBracket, '.').split('.');
  return get(object, cleanPath, defaultValue);
};

function get(object, path, defaultValue) {
  var current = object;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var segment = _step.value;
      current = current[segment];

      if (current == null) {
        return defaultValue;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return current;
}